/* ==========================================================================
   LABOTECA — comportamientos propios
   Archivo nuestro, no del fabricante. Se carga desde layout/theme.liquid.
   ========================================================================== */

(function () {
  'use strict';

  var SEL_TABS = '[id^="shopify-section-"][id$="__tabs"]';
  var SEL_FBT = '.cbb-frequently-bought-container';
  var MOVIL = '(max-width: 767px)';

  function tabs() { return document.querySelector(SEL_TABS); }

  /* ------------------------------------------------------------------------
     1) En movil, subir el bloque de pestanas para que quede justo debajo del
        boton de compra.

     Por que con JavaScript y no con CSS: el bloque de pestanas es una SECCION
     hermana de la del producto, no vive dentro de ella. La propiedad order de
     CSS solo reordena elementos que comparten padre.

     Se guarda el lugar original en una marca invisible para poder devolverlo.
     ------------------------------------------------------------------------ */
  function pestanasEnMovil() {
    var t = tabs();
    if (!t) return;

    var marca = document.getElementById('labo-tabs-origen');
    if (!marca) {
      marca = document.createElement('div');
      marca.id = 'labo-tabs-origen';
      marca.hidden = true;
      t.parentNode.insertBefore(marca, t);
    }

    if (window.matchMedia(MOVIL).matches) {
      var boton = document.querySelector('.labo-buy-now');
      if (!boton) return;
      var destino = boton.closest('.hdt-product-info__item');
      if (!destino || !destino.parentNode) return;
      if (destino.nextElementSibling === t) return;
      destino.parentNode.insertBefore(t, destino.nextSibling);
    } else {
      // de vuelta a su lugar original
      if (marca.nextElementSibling === t) return;
      marca.parentNode.insertBefore(t, marca.nextSibling);
    }
  }

  /* ------------------------------------------------------------------------
     2) Mover "Comprados juntos habitualmente" para que quede DESPUES de las
        pestanas.

        La app lo inyecta dentro de la columna del producto y ocupa cerca de
        600px, lo que empujaba la descripcion y las especificaciones muy abajo:
        habia que bajar hasta ~2250px para leerlas. Moviendolo aqui, suben unos
        600px.

        La app lo dibuja tarde y puede volver a dibujarlo, por eso se vigila el
        DOM en vez de hacerlo una sola vez.
     ------------------------------------------------------------------------ */
  function fbtDespuesDePestanas() {
    var fbt = document.querySelector(SEL_FBT);
    var t = tabs();
    if (!fbt || !t) return;
    if (fbt.previousElementSibling === t) return; // ya esta donde toca
    t.parentNode.insertBefore(fbt, t.nextSibling);
  }

  function acomodar() {
    try {
      pestanasEnMovil();
      fbtDespuesDePestanas();
    } catch (e) {
      /* si algo falla, la pagina se queda como estaba */
    }
  }

  function arrancar() {
    acomodar();

    // la app de "comprados juntos" carga despues; se vigila su aparicion
    if (window.MutationObserver && document.body) {
      var pendiente = false;
      new MutationObserver(function () {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(function () { pendiente = false; acomodar(); });
      }).observe(document.body, { childList: true, subtree: true });
    }

    // al cambiar el ancho: matchMedia no siempre dispara, se refuerza con resize
    var mq = window.matchMedia(MOVIL);
    if (mq.addEventListener) mq.addEventListener('change', acomodar);
    else if (mq.addListener) mq.addListener(acomodar);

    var temporizador;
    window.addEventListener('resize', function () {
      clearTimeout(temporizador);
      temporizador = setTimeout(acomodar, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
